export default "__VITE_ASSET__9142a67e__"